/**
 * Service search links (D22, T15): every link to the service search derives its listing types
 * from the runtime listing configuration (Console), never from a hardcoded list, so adding or
 * retiring a service listing type needs no code change.
 */

/**
 * Service listing types: every listing type from the runtime listing configuration except tasks,
 * in configuration order. Empty when no service type is configured.
 *
 * @param {Object} config runtime configuration
 * @returns {Array<string>} listing type ids
 */
export const getServiceListingTypes = config =>
  (config?.listing?.listingTypes || [])
    .map(t => t?.listingType)
    .filter(t => typeof t === 'string' && t && t !== 'tasks');

/**
 * SearchPage query string for a service search: `?pub_listingType=<types>` (comma encoded as %2C)
 * plus the optional category filters. Without service types the link uses the filters only, and
 * an unfiltered link without service types is the plain search page ('').
 *
 * @param {Array<string>} serviceTypes from getServiceListingTypes
 * @param {Object} [filters]
 * @param {string} [filters.categoryLevel1]
 * @param {string} [filters.categoryLevel2] only used together with categoryLevel1
 * @returns {string} query string starting with '?', or ''
 */
export const serviceSearchQuery = (serviceTypes = [], filters = {}) => {
  const { categoryLevel1, categoryLevel2 } = filters;
  const params = [
    serviceTypes.length > 0
      ? `pub_listingType=${encodeURIComponent(serviceTypes.join(','))}`
      : null,
    categoryLevel1 ? `pub_categoryLevel1=${encodeURIComponent(categoryLevel1)}` : null,
    categoryLevel1 && categoryLevel2
      ? `pub_categoryLevel2=${encodeURIComponent(categoryLevel2)}`
      : null,
  ].filter(Boolean);
  return params.length > 0 ? `?${params.join('&')}` : '';
};
